import { createAsyncThunk } from "@reduxjs/toolkit";
import { createGraphQLThunk } from ".";
import { GET_ALL_BRANDS, GET_BRANDS } from "../../utils/queries";

export const brandsThunk = createAsyncThunk(
  "brandsSlice/brandsThunk",
  createGraphQLThunk({
    query: GET_BRANDS,
    responseKey: "getBrandsBySeller",
  })
);

export const GetAllBrands = createAsyncThunk(
  "allBrandsSlice/GetAllBrands",
  createGraphQLThunk({
    query: GET_ALL_BRANDS,
    responseKey: "getCompanies",
  })
);
